<section class="dashboard">
    <app-nav-bar></app-nav-bar>
    <div class="d-flex align-items-stretch" style="min-height: 70vh;">
<app-side-bar class="animate__animated animate__slideInLeft"></app-side-bar>
<div class="page-content">
    <div class="page-header animate__animated animate__jackInTheBox animate__delay-1s" style="background-color: #19b2e2; color: #f1f1f1;" *ngIf="barVisible">
        <div class="container-fluid">
          <h2 class="h5 no-margin-bottom"><i (click)="removeBar()" class="animate__animated animate__bounceIn animate__faster animate__infinite" style="color: yellow;" class="fa fa-hand-peace-o"></i> Good {{greet}} {{userName}} </h2>
        </div>
      </div>
    <router-outlet></router-outlet>
</div>
    </div>
<!-- <app-board></app-board>
<app-thrift-table></app-thrift-table> -->
</section>



